"use client"

import { usePage } from "@inertiajs/react"

import { MarketingUserMenu } from "@/components/marketing/user-menu"
import { Link } from "@/components/ui/link"
import { publicNavItems } from "@/constants/public-nav"

import { cx } from "@uui/utils/cx"

/**
 * Desktop bar for the authenticated shell's content column: the public
 * wayfinding set plus the compact avatar menu, in the light PublicHeader's
 * frosted idiom. Deliberately sparse — the rail owns the brand lockup and the
 * full name+email identity area, so no logo here. Below `lg` the shell's
 * MobileNavigationHeader is the header; this one hides.
 */
export const DashboardHeader = () => {
  const { url } = usePage()
  const path = url.split("?")[0]

  const isCurrent = (href: string) =>
    href === "/" ? path === "/" : path === href || path.startsWith(`${href}/`)

  return (
    <header className="border-secondary bg-surface-base/90 sticky top-0 z-30 hidden border-b backdrop-blur-sm lg:block">
      <div className="max-w-container mx-auto flex items-center justify-between gap-6 px-4 py-3 lg:px-8">
        <nav aria-label="Explore">
          <ul className="flex items-center gap-5">
            {publicNavItems.map((item) => (
              <li key={item.label}>
                <Link
                  href={item.href}
                  variant="muted"
                  aria-current={isCurrent(item.href) ? "page" : undefined}
                  className={cx(
                    "outline-focus-ring text-tertiary hover:text-primary rounded-xs text-sm font-medium whitespace-nowrap transition-colors focus-visible:outline-2 focus-visible:outline-offset-2",
                    isCurrent(item.href) && "text-primary font-semibold",
                  )}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <MarketingUserMenu />
      </div>
    </header>
  )
}
